import { useQuery } from '@based/sdk/react'
import { EventCard } from '@app/components/blocks/event/EventCard'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import type { ListEventModel } from 'functions/app/event/list'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { pages } from '@app/util/links'

export const Events = ({ initiativeId }: { initiativeId: number }) => {
  const translations = useTranslations().app
  const initiativeEventsQuery: { data?: ListEventModel[] } = useQuery(
    'list-event',
    {
      initiativeId,
    },
  )
  const events = initiativeEventsQuery.data

  if (!events || events.length === 0) {
    return (
      <Column gap="1rem">
        <Text.Medium color="var(--palette-blue-600)">
          {translations.initiativePage.noEvents}
        </Text.Medium>
      </Column>
    )
  }

  return (
    <Column gap="1.5rem">
      {events.map((event) => {
        return (
          <EventCard
            key={event.uuid}
            title={event.title}
            start={event.start}
            end={event.end}
            image={event.images?.[0]?.src ?? defaultProjectPicture}
            imageAlt={event.images?.[0]?.alt}
            to={pages?.event?.(event.slug)}
          />
        )
      })}
    </Column>
  )
}
